<template>
    <div class="main-grids">
        <div class="recommended">
            <div class="recommended-grids">
                <div class="recommended-info">
                    <h3>最新影片</h3>
                </div>
                <videoList :data="videoArray"></videoList>
            </div>
        </div>
    </div>
</template>

<script>
import videoList from '@/components/VideoList'

export default {
  name: '',
  data () {
    return {
      videoArray: []
    }
  },
  components: {
    videoList
  },
  mounted () {
    this.getVideoList()
  },
  methods: {
    getVideoList () {
      let self = this
      this.$http.get('/getVideos/home/8/1', {
        params: {
          pageSize: 12,
          page: 1
        }
      })
        .then(response => {
          self.videoArray = response.data.list
        }).catch(err => {
          console.log(err.response.data.msg)
        })
    }
  }
}
</script>
